import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import CartFooter from "../common/CartFooter";
import { HiPlus, HiMinus } from 'react-icons/hi';

function PaySuccess() {

    return(
        <>
          <div className="container">
             <div className="cart-wrap">
                <div className="cartNav">
                    <ul>
                        <li><Link to="/cart">my shopping cart</Link></li>
                        <li><Link to="/patient-details">patient details</Link></li>
                        <li><Link className="active" to="/pay">pay</Link></li>
                    </ul>
                    <div className="cartClose"><img alt="" src={require('../images/icons/close.png')} /></div>
                </div>
                <div className="cart-list">
                    <h2 className="title left">Payment successful</h2>
                    <div className="pay-success">
                      <p className="pt-4">Thank you for your order, <br /> We’ve emailed you the order details to: <span>email@email.com</span></p>
                      <div className='payBox'>
                      <h4>order details</h4>
                      <p className="pt-3">Your order Id: <strong>#00012312</strong> <br />
                          You paid us today: <strong>£ 28.60</strong>
                       </p>
                      </div>
                    </div>

                    <div className="cart-list-group forDesk">
                        <h3>treatments</h3>
                        <div className="table-div">
                        <div className="table-row thead">
                            <div className="table-col head">Name</div>
                            <div className="table-col head">Appointment</div>
                            <div className="table-col head">quantity</div>
                            <div className="table-col head">price</div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/product/lip-filter.png')} /></div>
                                    <span>Lip filler</span>
                                </div>
                            </div>
                            <div className="table-col">
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className="table-col"><span>0.5 ML</span></div>
                            <div className="table-col"><span>£ 27.99</span></div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/product/bum.jpg')} /></div>
                                    <span>Brazilian bum lift consultation</span>
                                </div>
                            </div>
                            <div className="table-col">
                              <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className="table-col"><span>1</span></div>
                            <div className="table-col"><span>£ 34.99</span></div>
                        </div>
                        </div>
                    </div>

                    {/* For Mobile View Only */}
                        <div className="listMob">
                            <h3>treatments</h3>
                            <div className='listMob-group'>
                            <div className="listMob-single">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/product/lip-filter.png')} /></div>
                                    <span>Lip filler</span>
                                </div>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Appointment</span>
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Quantity</span>
                                <span>0.5 ML</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Price</span>
                                <span>£ 34.99</span>
                            </div>
                            </div>
                            <div className='listMob-group'>
                            <div className="listMob-single">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/product/bum.jpg')} /></div>
                                    <span>Brazilian bum lift consultation</span>
                                </div>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Appointment</span>
                                <span>03 Oct 2022, 14 : 30 PM</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Quantity</span>
                                <span>1</span>
                            </div>
                            <div className='listMob-single-col'>
                                <span>Price</span>
                                <span>£ 34.99</span>
                            </div>
                            </div>
                        </div>
                    {/* For Mobile View Only */}

                    <div className="cart-list-group forDesk">
                        <h3>Products</h3>
                        <div className="table-div for-product">
                        <div className="table-row thead">
                            <div className="table-col head">Name</div>
                            <div className="table-col head">Price per unit</div>
                            <div className="table-col head">Quantity</div>
                            <div className="table-col head">Total Price</div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/pro.png')} /></div>
                                    <span>Aqua lux</span>
                                </div>
                            </div>
                            <div className="table-col"><span>£ 49.00</span></div>
                            <div className="table-col">
                                <span>10</span>
                            </div>
                            <div className="table-col bookLast"><span>£ 49.00</span></div>
                        </div>
                        <div className="table-row">
                            <div className="table-col">
                                <div className="productName">
                                    <div className="productImage"><img alt="" src={require('../images/pro.png')} /></div>
                                    <span>Aqua premium</span>
                                </div>
                            </div>
                            <div className="table-col"><span>£ 49.00</span></div>
                            <div className="table-col">
                                <span>5</span>
                            </div>
                            <div className="table-col bookLast"><span>£ 49.00</span></div>
                        </div>
                        </div>
                    </div>

                    <div className='listMob'>
                       <h3>Products</h3>
                       <div className='listMob-group'>
                          <div className='listMob-single'>
                            <div className="productName">
                                <div className="productImage"><img alt="" src={require('../images/pro.png')} /></div>
                                <span>Aqua lux</span>
                            </div>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Price per unit</span>
                            <span>£ 49.00</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Quantity</span>
                            <span>10</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Total Price</span>
                            <span>£ 49.00</span>
                          </div>
                       </div>
                       <div className='listMob-group'>
                          <div className='listMob-single'>
                            <div className="productName">
                                <div className="productImage"><img alt="" src={require('../images/pro.png')} /></div>
                                <span>Aqua premium</span>
                            </div>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Price per unit</span>
                            <span>£ 49.00</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Quantity</span>
                            <span>10</span>
                          </div>
                          <div className='listMob-single-col'>
                            <span>Total Price</span>
                            <span>£ 49.00</span>
                          </div>
                       </div>
                    </div>

                </div>
             </div>
          </div>

          <div className="cart-footer">
              <div className="container">
                  <div className="price-cont">
                    <span>Total price :</span>
                    <span>£ -</span>
                  </div>
                  <div className="priceButton">
                    <button className="themeBtn line">Close</button>
                    <Link to="/faq" className="themeBtn">Visit FAQ</Link>
                  </div>
              </div>

              <CartFooter/>

          </div>


        </>
    )
}

export default PaySuccess;